import { clearAuthState } from './tokenUtils';
import store from '../store';

class AccountStatusChecker {
  constructor() {
    this.statusInterval = null;
  }

  startChecking() {
    if (this.statusInterval) return;
    
    // Check status immediately and then every 15 min
    this.checkStatus();
    this.statusInterval = setInterval(() => {
      this.checkStatus();
    }, 900000);
  }
  
  async checkStatus() {
    const state = store.getState();
    const user = state.auth?.user;
    if (!user) return;
    
    const userId = user.almataPartner?.id || user.oemPartner?.id;
    if (!userId) return;
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://riskreport.almata.co.jp:3400/api'}/socket/status?userId=${userId}`);
      const data = await response.json();
      
      if (response.status === 403 || response.status === 404) {
        this.handleAccountIssue(data.message || 'Your account is inactive. Please contact the administrator for more details.');
      }
    } catch (error) {
      // Silent fail
    }
  }

  stopChecking() {
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
      this.statusInterval = null;
    }
  }



  handleAccountIssue(message) {
    this.stopChecking();
    sessionStorage.clear();
    localStorage.clear();
    
    try {
      const state = store.getState();
      if (state.auth) {
        store.dispatch({ type: 'CLEAR_USER' });
        store.dispatch({ type: 'LOGOUT_SUCCESS' });
      }
    } catch (error) {
      // Silent fail
    }
    
    alert(message);
    window.location.href = '/login';
    window.location.reload();
  }

  redirectToLogin() {
    window.location.replace('/login');
  }
}

export const accountStatusChecker = new AccountStatusChecker();